import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../../mutation-types';
import KanbanBoardsAPI from '../../../api/kanbanBoards';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getBoards(_state) {
    return [..._state.records].sort((a, b) => a.position - b.position);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getDefaultBoard(_state) {
    return _state.records.find(board => board.is_default);
  },
  getBoardById: _state => id =>
    _state.records.find(record => record.id === Number(id)),
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_KANBAN_BOARDS_UI_FLAG, { isFetching: true });
    try {
      const response = await KanbanBoardsAPI.get();
      commit(types.SET_KANBAN_BOARDS, response.data);
    } finally {
      commit(types.SET_KANBAN_BOARDS_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, boardObj) => {
    commit(types.SET_KANBAN_BOARDS_UI_FLAG, { isCreating: true });
    try {
      const response = await KanbanBoardsAPI.create(boardObj);
      commit(types.ADD_KANBAN_BOARD, response.data);
      return response.data;
    } finally {
      commit(types.SET_KANBAN_BOARDS_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_KANBAN_BOARDS_UI_FLAG, { isUpdating: true });
    try {
      const response = await KanbanBoardsAPI.update(id, updateObj);
      commit(types.EDIT_KANBAN_BOARD, response.data);
      return response.data;
    } finally {
      commit(types.SET_KANBAN_BOARDS_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_KANBAN_BOARDS_UI_FLAG, { isDeleting: true });
    try {
      await KanbanBoardsAPI.delete(id);
      commit(types.DELETE_KANBAN_BOARD, id);
    } finally {
      commit(types.SET_KANBAN_BOARDS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_KANBAN_BOARDS_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_KANBAN_BOARDS]: MutationHelpers.set,
  [types.ADD_KANBAN_BOARD]: MutationHelpers.create,
  [types.EDIT_KANBAN_BOARD]: MutationHelpers.update,
  [types.DELETE_KANBAN_BOARD]: MutationHelpers.destroy,
};

export default { namespaced: true, state, getters, actions, mutations };
